var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyclicArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.88889C12 4.88889 10.8392 3.37123 9.8962 2.46569C8.95318 1.56015 7.65002 1 6.21053 1C3.33283 1 1 3.23858 1 6C1 8.76142 3.33283 11 6.21053 11C8.586 11 10.5902 9.4746 11.2174 7.38889M12 4.88889V1.55556M12 4.88889H8.52632",
    stroke: "#9193AA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclicArrow);
export default __webpack_public_path__ + "static/media/cyclic-arrow.8bc35b18f27cc4a2f3fce71c9336010c.svg";
export { ForwardRef as ReactComponent };